export function createCards(items, minimum) {
    const wrap = (item, iteration, index) => ({
        key: `${iteration}-${index}`,
        index,
        item,
    });
    if (minimum === undefined || minimum <= items.length) {
        return items.map((item, index) => wrap(item, 0, index));
    }
    const duplicates = Math.ceil(minimum / items.length) - 1;
    const duplicatedItems = Array(duplicates).fill(items);
    return [
        ...items.map((item, index) => wrap(item, 0, index)),
        ...duplicatedItems.map((items, index) => items.map((item, itemIndex) => wrap(item, index + 1, itemIndex))).flat(1),
    ];
}
export function getWrapAroundDistance(from, to, length) {
    const halfLength = Math.floor(length / 2);
    const distance = to - from;
    return distance > halfLength ? distance - length : distance < -halfLength ? distance + length : distance;
}
